import { type ReactNode } from 'react'

import { AnchorTarget } from '@/components/common/AnchorTarget'
import { StyledContent } from '@/components/common/StyledContent'
import { type useScrollspy } from '@/components/providers/ScrollspyProvider'
import { type WPGuideType } from '@/defs/wordpress'

import styles from './GuideContentSection.module.scss'

type Props = {
  content: ReactNode
  number: number
  section: WPGuideType[number]['sections'][number]
  sectionRef?: ReturnType<typeof useScrollspy>['refs'][string]
}

export const GuideContentSection = ({ content, number, section, sectionRef }: Props) => (
  <div ref={sectionRef}>
    <AnchorTarget additionalOffset='var(--layout-filters-button-width)' id={section.slug} />
    <h2 className={styles.sectionLabel}>
      <span className={styles.sectionLabelNumber}>{number}.</span>
      {section.label}
    </h2>
    <StyledContent>{content}</StyledContent>
  </div>
)
